/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../utils/apiClient';
import { restructureCommentModel } from '../restructuring';
import { restructurePaginationModel } from '../../../common/restructuring';

class CommentsService {
  async getCommentsList(state, queryParams) {
    // console.log(queryParams);
    const response = await api.get('/comments', {
      expand: 'author,author_profile,children,comment_object',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    const childComments = _.flatten(
      _.map(responseJson.data.items, item =>
        _.map(item.children, children => restructureCommentModel(children))
      )
    );
    return {
      response: responseJson,
      destructData: {
        commentsById: _.keyBy(
          _.map(responseJson.data.items, item => restructureCommentModel(item)),
          'id'
        ),
        commentsIds: _.map(responseJson.data.items, item => item.id),
        childCommentsById: _.keyBy(childComments, 'id'),
        childCommentsMapParent: _.chain(childComments)
          .groupBy('parentId')
          .mapValues(item => _.map(item, children => children.id))
          .value(),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async sendComment(state, queryParams) {
    const response = await api.post(
      '/comments',
      { expand: 'author,author_profile,comment_object' },
      queryParams
    );
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new CommentsService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/comments/services/CommentsService.js